import * as React from "react";
import type { SVGProps } from "react";
const SvgBancontactCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="url(#bancontact-card_svg__a)"
      d="M2 16.52h20v2.61a2.56 2.56 0 0 1-2.56 2.56H2z"
    />
    <path
      fill="#fff"
      d="M9.33 19.8c-.44 0-.7-.37-.62-.81s.47-.8.9-.8q.4.01.56.31l.42-.27a1 1 0 0 0-.9-.5c-.7 0-1.35.57-1.47 1.26-.13.7.33 1.27 1.02 1.27.41 0 .81-.2 1.08-.51l-.32-.28q-.27.31-.67.32m2.69-1.02c-.08-.17-.28-.26-.5-.26-.47 0-.86.36-.95.88-.1.51.18.87.64.87a.8.8 0 0 0 .6-.28l-.04.23h.46l.3-1.66h-.47zm-.12.62a.54.54 0 0 1-.51.43c-.24 0-.4-.2-.35-.43a.5.5 0 0 1 .5-.45c.23 0 .4.2.36.45m2.02-.88q-.32-.01-.55.4l.06-.36h-.46l-.3 1.66h.47l.1-.56q.15-.71.53-.7.09-.02.22.06l.19-.45a1 1 0 0 0-.26-.05m1.82-.86-.2 1.1c-.08-.16-.3-.24-.48-.24-.43 0-.87.34-.97.87-.09.54.24.88.66.88a.8.8 0 0 0 .58-.25l-.04.2h.47l.45-2.56zm-.31 1.73a.54.54 0 0 1-.51.44c-.23 0-.4-.2-.35-.44a.54.54 0 0 1 .5-.43c.23 0 .4.18.36.43M2.85 2.31h18.3c.47 0 .85.38.85.85v13.36H2V3.16c0-.47.38-.85.85-.85"
    />
    <mask
      id="bancontact-card_svg__b"
      width={9}
      height={4}
      x={12}
      y={4}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill="#fff"
        d="M16.85 4.28c-2.42 0-3.63 1.62-4.84 3.23h8.03V4.28z"
      />
    </mask>
    <g mask="url(#bancontact-card_svg__b)">
      <path fill="url(#bancontact-card_svg__c)" d="M20.04 4.28H12v3.23h8.03z" />
    </g>
    <mask
      id="bancontact-card_svg__d"
      width={10}
      height={4}
      x={3}
      y={7}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path fill="#fff" d="M3.98 7.51v3.24h3.19c2.42 0 3.63-1.62 4.84-3.24z" />
    </mask>
    <g mask="url(#bancontact-card_svg__d)">
      <path fill="url(#bancontact-card_svg__e)" d="M12 7.51H3.99v3.24H12z" />
    </g>
    <path
      fill="#0b2265"
      d="m5.35 13.23-.17-.07a.4.4 0 0 0 .2-.14q.09-.14.09-.31t-.08-.3a.5.5 0 0 0-.22-.2 1 1 0 0 0-.33-.06h-.86v2.17h.92q.23 0 .38-.09t.23-.23a.7.7 0 0 0 .02-.57 1 1 0 0 0-.18-.2m-.37-.63q.05.06.05.17t-.06.18a.2.2 0 0 1-.16.06h-.4v-.48h.4q.1 0 .17.07m.13 1.2a.3.3 0 0 1-.1.1.3.3 0 0 1-.17.04h-.43v-.56h.44q.1-.01.16.04.07.04.1.1a.3.3 0 0 1 0 .28M7 13.04 6.99 13a1 1 0 0 0-.2-.14.69.69 0 0 0-.87.32 1 1 0 0 0-.1.4q0 .25.1.4a.7.7 0 0 0 .86.33.5.5 0 0 0 .24-.2v.21h.4v-1.47h-.4zm-.06.74a.4.4 0 0 1-.14.14.4.4 0 0 1-.19.06.4.4 0 0 1-.2-.06.4.4 0 0 1-.13-.14.4.4 0 0 1 .14-.53.4.4 0 0 1 .19-.06q.1 0 .19.05a.4.4 0 0 1 .2.35q0 .1-.06.2m2.01-.89a.6.6 0 0 0-.52-.05 1 1 0 0 0-.18.13l-.06.1v-.23h-.41v1.47h.4v-.77q0-.14.06-.2a.3.3 0 0 1 .12-.12q.07-.03.16-.03t.14.04q.06.03.1.11t.04.19v.78h.41v-.8a1 1 0 0 0-.06-.38.5.5 0 0 0-.2-.25m1.5 1.05a.4.4 0 0 1-.38-.01.4.4 0 0 1-.14-.15.4.4 0 0 1 0-.4.4.4 0 0 1 .35-.19l.17.04q.09.05.14.11l.3-.22a.8.8 0 0 0-.62-.3 1 1 0 0 0-.4.09 1 1 0 0 0-.3.27 1 1 0 0 0-.1.4.8.8 0 0 0 .4.68.8.8 0 0 0 .76.02q.16-.1.26-.23l-.3-.22a.3.3 0 0 1-.14.1m1.73-1.03a1 1 0 0 0-.39-.09.8.8 0 0 0-.68.37 1 1 0 0 0-.1.4.8.8 0 0 0 .4.68q.17.1.38.1t.4-.1a.8.8 0 0 0 .4-.68.8.8 0 0 0-.4-.67m-.06.89a.37.37 0 0 1-.65 0 .4.4 0 0 1-.05-.2.4.4 0 0 1 .05-.2.37.37 0 0 1 .51-.15q.08.05.14.14a.4.4 0 0 1 .05.2q0 .12-.05.2m1.9-.89a.6.6 0 0 0-.52-.05 1 1 0 0 0-.18.13l-.07.1v-.23h-.4v1.47h.4v-.77q0-.14.05-.2a.3.3 0 0 1 .13-.12q.07-.03.16-.03t.14.04q.06.03.1.11.03.07.04.19v.78h.4v-.8a1 1 0 0 0-.06-.38.5.5 0 0 0-.2-.25m1.12-.58h-.41v.54h-.26v.32h.26v1.15h.41v-1.15h.31v-.32h-.3zm1.62.73-.03-.04a1 1 0 0 0-.2-.14.69.69 0 0 0-.87.32 1 1 0 0 0-.1.4q0 .25.1.4a.7.7 0 0 0 .87.33.5.5 0 0 0 .23-.2v.21h.41v-1.47h-.4zm-.06.74a.4.4 0 0 1-.14.14.4.4 0 0 1-.2.06.4.4 0 0 1-.19-.06.4.4 0 0 1-.13-.14.4.4 0 0 1 .14-.53.4.4 0 0 1 .19-.06q.1 0 .19.05a.4.4 0 0 1 .19.35q0 .1-.05.2m1.73.15a.4.4 0 0 1-.38-.01.4.4 0 0 1-.14-.15.4.4 0 0 1 0-.4.4.4 0 0 1 .35-.19l.17.04q.09.05.14.11l.3-.22a.8.8 0 0 0-.62-.3 1 1 0 0 0-.4.09 1 1 0 0 0-.29.27 1 1 0 0 0-.11.4.8.8 0 0 0 .4.68.8.8 0 0 0 .76.02q.16-.1.26-.23l-.3-.22a.3.3 0 0 1-.14.1m1.58-1.08h-.31v-.54h-.41v.54h-.27v.32h.27v1.15h.41v-1.15h.31z"
    />
    <defs>
      <linearGradient
        id="bancontact-card_svg__a"
        x1={2}
        x2={22}
        y1={19.11}
        y2={19.11}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={1} stopColor="#0b2265" />
        <stop offset={0.75} stopColor="#0439d1" />
        <stop offset={1} stopColor="#0439d1" />
      </linearGradient>
      <linearGradient
        id="bancontact-card_svg__c"
        x1={12.01}
        x2={20.04}
        y1={5.9}
        y2={5.9}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={1} stopColor="#ff9700" />
        <stop offset={0.75} stopColor="#ffd400" />
        <stop offset={1} stopColor="#ffd400" />
      </linearGradient>
      <linearGradient
        id="bancontact-card_svg__e"
        x1={4}
        x2={11.96}
        y1={9.14}
        y2={9.14}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={1} stopColor="#0439d1" />
        <stop offset={0.25} stopColor="#0439d1" />
        <stop offset={1} stopColor="#0b2265" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgBancontactCard;
